import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSupportDialogBox } from '~/components/support/ducks';
import * as Paths from '~/components/router/constants';
import { useRouter } from '~/utils/navigation';
import { isBridgeAvailable } from '~/components/app-bridge/index.js';

const HubSupport = () => {
	const dispatch = useDispatch();
	const router = useRouter();

	useEffect(() => {
		if (!isBridgeAvailable()) {
			// Only show support dialog automatically & navigate back to Hub if it's not launched from mobile apps
			dispatch(showSupportDialogBox(true));
			router.push(Paths.ROUTE_HUB);
		}
	}, [dispatch, router]);

	return null;
};

export default HubSupport;
